import { render, staticRenderFns } from "./AlisFaturasiRaporu.vue?vue&type=template&id=4ada9c44&scoped=true"
import script from "./AlisFaturasiRaporu.vue?vue&type=script&lang=js"
export * from "./AlisFaturasiRaporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada9c44",
  null
  
)

export default component.exports